import * as THREE from 'three';
import { PainterContext, TransitionPainter } from '../types';
import { easeInOutCubic } from '../easing';

const SLICES = 14;
const COLORS = [
  '#6366F1', '#8B5CF6', '#06B6D4', '#a5b4fc',
  '#7cadde', '#818CF8', '#5B8DEF',
];

/**
 * Iris: radial wedges fan out from center on exit, contract on enter.
 * Ported from the queens app with a staggered wedge effect.
 */
export function createIrisPainter(): TransitionPainter {
  const meshes: THREE.Mesh[] = [];

  return {
    setup({ scene }) {
      for (let i = 0; i < SLICES; i++) {
        const angle = (i / SLICES) * Math.PI * 2;
        const nextAngle = ((i + 1) / SLICES) * Math.PI * 2;
        const r = 3;
        const geo = new THREE.BufferGeometry();
        const vertices = new Float32Array([
          0, 0, 0,
          Math.cos(angle) * r, Math.sin(angle) * r, 0,
          Math.cos(nextAngle) * r, Math.sin(nextAngle) * r, 0,
        ]);
        geo.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
        const mat = new THREE.MeshBasicMaterial({ color: COLORS[i % COLORS.length] });
        const mesh = new THREE.Mesh(geo, mat);
        mesh.visible = false;
        scene.add(mesh);
        meshes.push(mesh);
      }
    },
    update(phase, t) {
      meshes.forEach((mesh, i) => {
        const stagger = (i / SLICES) * 0.25;
        const adjusted = Math.min(1, Math.max(0, (t - stagger) / (1 - stagger)));
        const eased = easeInOutCubic(adjusted);
        mesh.scale.setScalar(phase === 'exit' ? eased : 1 - eased);
        mesh.visible = true;
      });
    },
    hide() {
      meshes.forEach((m) => { m.visible = false; });
    },
    dispose() {
      meshes.forEach((m) => {
        m.geometry.dispose();
        (m.material as THREE.Material).dispose();
      });
      meshes.length = 0;
    },
  };
}
